<template lang="pug">
  div
    modal-trabajadores-area(
      v-if="mostrarModalTrabajadores"
      :trabajadores="trabajadoresArea"
      :seleccionados="trabajadoresSeleccionados"
      :nombre-area="nombreArea"
      :is-loading="isLoadingTrabajadores"
      @aceptar="aceptarTrabajadores"
      @close="mostrarModalTrabajadores = false"
    )
    .cambio-dias

      .title
        span.little Cambio de días en vacaciones

        span.icon.close(
          @click="$emit('close')"
        )
          i.fa.fa-close

      transition-group.contenedor-datos(name="fade-smooth", tag="div")
        .indicaciones(v-if="empleado && empleado.codigo", key="indicaciones-cambio-dias")
          .title
            span Datos a tener en cuenta
          ul.list
            li.list-item
              span Ingresando cambio de días para&nbsp;
              strong {{ empleado.nombre }}
            li.list-item
              span Su jefe es&nbsp;
              strong {{ empleado.nombreJefe }}
            li.list-item
              span Días por tomar&nbsp;
              strong  {{ empleado.diasReales }}
            li.list-item
              span Días por programar&nbsp;
              strong  {{ empleado.diasDisponibles }}
            li.list-item
              span Le llegará un mail de notificación a&nbsp;
              strong {{ empleado.nombre }}&nbsp;
              span con los días cambiados
            hr
            li.list-item
              span Va a&nbsp;
              strong(v-if="signo === '-'") quitar&nbsp;
              strong(v-else) agregar&nbsp;
              strong {{ dias }}&nbsp;
              span {{dias === 1 ? 'día ' : 'días '}} a&nbsp;
              strong {{ empleado.nombre }}
            li.list-item
              span Sus días quedarían de esta manera
            li.list-item
              span Días por tomar&nbsp;
              strong(v-if="signo === '-'") {{ +empleado.diasReales - +dias }}
              strong(v-else) {{ +empleado.diasReales + +dias }}
            li.list-item
              span Días por programar&nbsp;
              strong(v-if="signo === '-'") {{ +empleado.diasDisponibles - +dias }}
              strong(v-else) {{ +empleado.diasDisponibles + +dias }}


        .contenedor-transaccion(key="transaccion")
          .flex-data
            .flex.jcc
              .control.margin-bottom-10
                label.radio
                  input.radio(
                    type="radio",
                    name="opciones"
                    v-model="opcionCambiarDias"
                    @change="handlerModalidad"
                    value="individual"
                  )
                  span.margin-left-5 Individual
                label.radio(v-if="empresa !== 'raymisa'")
                  input.radio(
                    type="radio",
                    name="opciones"
                    v-model="opcionCambiarDias"
                    value="area"
                    @change="handlerModalidad"
                  )
                  span.margin-left-5 Área
                label.radio
                  input.radio(
                    type="radio",
                    name="opciones"
                    v-model="opcionCambiarDias"
                    @change="handlerModalidad"
                    value="todo"
                  )
                  span.margin-left-5 Toda la empresa
            .flex.jcc(v-if="empresa !== 'raymisa' && opcionCambiarDias === 'area'")
              .control.flex-1.title-singular
                p Area
                .input-container
                  input.input(
                    type="text",
                    v-model="idArea"
                    :disabled="isLoading"
                    readonly
                    @click="mostrarBusquedaArea = true"
                    v-if="!idArea"
                  )
                  .item.fdc.flex-1(v-else)
                    span {{ nombreArea | capitalize }}
                    span.name {{ nombreGerencia }}
                  span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaArea = true")
                    i.fa.fa-search
                  .erase-data(@click="borrarArea")
                    .icon
                      .fa.fa-times
                transition(name="fade-quick")
                  .pop-over(
                      v-if="mostrarBusquedaArea"
                    )
                    lookup-area(
                      @selected="seleccionarArea"
                      @close="mostrarBusquedaArea = false"
                    )
            .resumen-seleccion(v-if="opcionCambiarDias === 'area' && idArea")
              template(v-if="cantidadTrabajadoresSeleccionados > 0")
                .resumen-contenido
                  span.icon
                    i.fa.fa-users

                  .resumen-texto
                    strong
                      | {{ cantidadTrabajadoresSeleccionados }}
                      | {{ cantidadTrabajadoresSeleccionados === 1 ? ' trabajador seleccionado' : ' trabajadores seleccionados' }}

                    span
                      | del área {{ nombreArea }}

                  button.button.button-small(
                    type="button"
                    @click="abrirModalTrabajadores"
                  )
                    i.fa.fa-pencil
                    span Modificar selección

              template(v-else)
                .sin-seleccion
                  span No hay trabajadores seleccionados.

                  button.button.button-small(
                    type="button"
                    @click="abrirModalTrabajadores"
                  )
                    i.fa.fa-users
                    span Seleccionar trabajadores
            .codigo-empleado(v-if="opcionCambiarDias === 'individual'")
              .control
                p Codigo de empleado
                input.input(
                  type="number",
                  v-model="codigoEmpleado"
                )
                span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaEmpleado = true")
                  i.fa.fa-search
              transition(name="fade-quick")
                .pop-over(
                    v-if="mostrarBusquedaEmpleado"
                  )
                    lookup-small-empleado(
                      @selected="seleccionarEmpleado"
                      @close="mostrarBusquedaEmpleado = false"
                      :codigo="codigoEmpleado"
                    )
            .dias(v-if="signo === '+'")
              .control
                p Días
                input.input(
                  type="number",
                  v-model="dias"
                )
            .contenedor-datos(v-if="signo === '-'")
              .control
                label Desde
                input.input(type="date", v-model="fechaInicioQuitaDia", @change="calculoDias")
              .control.margin-left-20
                label Hasta
                input.input(type="date", v-model="fechaFinQuitaDia", @change="calculoDias")
          .signo
            p ¿Que acción va a realizar?
            .opciones
              .opcion(
                @click="cambiarSigno('-')"
                :class="{'is-selected': signo === '-' }"
              )
                span Quitar días
              .opcion(
                @click="cambiarSigno('+')"
                :class="{'is-selected': signo === '+' }"
              )
                span Agregar días
          //- .contenedor-datos(v-if="signo === '-'")
          //-   .control
          //-     label Desde
          //-     input.input(type="date", v-model="fechaInicioQuitaDia")
          //-   .control.margin-left-20
          //-     label Hasta
          //-     input.input(type="date", v-model="fechaFinQuitaDia")
          .motivo
            div
              p Motivo
              p.subtitle Puedes seleccionar uno de los siguientes ejemplos y editarlos
              .motivos-ejemplo
                span(
                  v-for="o in motivosEjemplo"
                  @click="motivo = o"
                ) {{ o }}
              textarea.textarea(
                v-model="motivo"
              )
          .acciones
            button.button(
              @click="cambiar()"
              :class="{ 'is-loading': isSaving }"
            )
              span.icon.is-small
                i.fa.fa-save
              span Cambiar días
</template>

<script>
import { apiGet, apiPost, notify } from '../util/general'
import LookupSmallEmpleado from './Component_Lookup_Small_Empleado'
import Area                         from './lookups/Area'
import ModalTrabajadoresArea from './c_modal_trabajadores_area.vue'
import moment from 'moment'
export default {
  name: 'cambio_dias_vacaciones_component',
  components: {
    LookupSmallEmpleado,
    'lookup-area':Area,
    'modal-trabajadores-area' : ModalTrabajadoresArea
  },
  data () {
    return {
      empresa                 : process.env.EMPRESA,
      signo                   : '-',
      dias                    : 1,
      mostrarBusquedaEmpleado : false,
      codigoEmpleado          : '',
      motivo                  : '',
      empleado                : {},
      isSaving                : false,
      motivosEjemplo: [
        'Vacaciones no aprobadas oportunamente del xx/xx/xxxx al xx/xx/xxxx',
        'Retorno de días que quedaron del sistema anterior',
        'Se tomó días a cuenta de vacaciones del xx/xx/xxxx al xx/xx/xxxx por enfermedad'
      ],
      opcionCambiarDias: 'individual',
      isLoading : false,
      idArea: '',
      nombreArea: '',
      nombreGerencia: '',
      mostrarBusquedaArea : false,
      mostrarModalTrabajadores: false,
      trabajadoresArea: [],
      trabajadoresSeleccionados: [],
      isLoadingTrabajadores: false,
      fechaInicioQuitaDia   : moment().format('YYYY-MM-DD'),
      fechaFinQuitaDia      : moment().add(1, 'day').format('YYYY-MM-DD')
    }
  },
  computed: {
    cantidadTrabajadoresSeleccionados () {
      return this.trabajadoresSeleccionados.length
    },

    puedeCambiarDias () {
      if (!this.dias || Number(this.dias) <= 0) {
        return false
      }

      if (!this.motivo || !this.motivo.trim()) {
        return false
      }

      if (this.opcionCambiarDias === 'individual') {
        return this.empleado && this.empleado.codigo
      }

      if (this.opcionCambiarDias === 'area') {
        return (
          this.idArea &&
          this.trabajadoresSeleccionados.length > 0
        )
      }

      return this.opcionCambiarDias === 'todo'
    }
  },
  methods: {
    handlerModalidad () {
      var vm = this
      if (vm.opcionCambiarDias === 'individual') {
        vm.mostrarBusquedaArea = false
        vm.mostrarBusquedaEmpleado = true
      } else if (vm.opcionCambiarDias === 'area') {
        vm.empleado = {}
        vm.codigoEmpleado = ''
        vm.mostrarBusquedaArea = true
        vm.mostrarBusquedaEmpleado = false
        vm.borrarArea()
      } else if (vm.opcionCambiarDias === 'todo') {
        vm.mostrarBusquedaArea = false
        vm.mostrarBusquedaEmpleado = false
        vm.empleado = {}
        vm.codigoEmpleado = ''
      }
    },
    seleccionarArea (area) {
      this.idArea = area.codigo || area.idArea
      this.nombreArea = area.nombre || area.nombreArea
      this.nombreGerencia = area.nombreGerencia || area.gerencia || ''

      this.mostrarBusquedaArea = false

      // Limpiamos la selección anterior.
      this.trabajadoresSeleccionados = []
      this.trabajadoresArea = []

      this.cargarTrabajadoresArea()

      this.mostrarModalTrabajadores = true
    },
    cargarTrabajadoresArea () {
      var vm = this
      vm.isLoadingTrabajadores = true
      var obj = {
      }
      apiGet(vm, '/vacaciones/empleado/area/' + vm.idArea, obj, function (data) {
        vm.trabajadoresArea = data.data || []
      }, function (error) {
        vm.trabajadoresArea = []
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoadingTrabajadores = false
      })
    },
    aceptarTrabajadores (trabajadores) {
      this.trabajadoresSeleccionados = trabajadores
      this.mostrarModalTrabajadores = false
    },
    abrirModalTrabajadores () {
      if (!this.idArea) {
        return
      }

      this.mostrarModalTrabajadores = true
    },
    borrarArea () {
      this.idArea = ''
      this.nombreArea = ''
      this.nombreGerencia = ''
      this.trabajadoresArea = []
      this.trabajadoresSeleccionados = []
      this.mostrarModalTrabajadores = false
    },
    cambiarSigno (signo) {
      this.signo = signo
    },
    cambiar () {
      var vm = this
      vm.isSaving = true

      var obj = {
        codigoEmpleado : vm.codigoEmpleado,
        idArea         : vm.idArea,
        todaLaEmpresa   : vm.opcionCambiarDias === 'todo',
        dias           : +vm.dias,
        signo          : vm.signo,
        motivo         : vm.motivo,
        fechaInicio    : vm.fechaInicioQuitaDia ? vm.fechaInicioQuitaDia : null,
        fechaFin       : vm.fechaFinQuitaDia ? vm.fechaFinQuitaDia : null
      }

      if (vm.signo === '-') {
        var desde = moment(vm.fechaInicioQuitaDia, 'YYYY-MM-DD');
        var hasta = moment(vm.fechaFinQuitaDia, 'YYYY-MM-DD');

        if (!vm.fechaInicioQuitaDia) {
          notify(vm, 'error', 'Validación', 'Debe ingresar fecha desde')
          vm.isSaving = false
          return
        }
        if (!vm.fechaFinQuitaDia) {
          notify(vm, 'error', 'Validación', 'Debe ingresar fecha hasta')
          vm.isSaving = false
          return
        }
        if (desde.isAfter(hasta)) {
          notify(vm, 'error', 'Validación', 'La Fecha inicial no puede ser mayor a la fecha final')
          vm.isSaving = false
          return
        }

        obj.dias = hasta.diff(desde, 'days') + 1
      }

      if (vm.opcionCambiarDias === 'individual' && !obj.codigoEmpleado) {
        notify(vm, 'error', 'Validación', 'Debe ingresar el empleado')
        vm.isSaving = false
        return
      }
      if (vm.opcionCambiarDias === 'area' && !obj.idArea) {
        notify(vm, 'error', 'Validación', 'Debe ingresar una área')
        vm.isSaving = false
        return
      }

      if (obj.dias <= 0) {
        notify(vm, 'error', 'Validación', 'Debe ingresar un número de días en positivo')
        vm.isSaving = false
        return
      }

      if (!obj.motivo) {
        notify(vm, 'error', 'Validación', 'Debe ingresar un motivo')
        vm.isSaving = false
        return
      }

      // if (!vm.puedeCambiarDias) {
      //   notify(vm, 'error', 'Validación', 'Complete los datos requeridos antes de continuar')
      //   vm.isSaving = false
      //   return
      // }

      if (vm.opcionCambiarDias === 'area' && vm.trabajadoresSeleccionados.length === 0) {
        notify(vm, 'error', 'Validación', 'Debe seleccionar al menos un trabajador')
        vm.isSaving = false
        return
      }

      if (this.opcionCambiarDias === 'individual') {
        obj.codigoEmpleado = [this.empleado.codigo]
      }

      if (this.opcionCambiarDias === 'area') {
        obj.idArea = this.idArea

        obj.codigoEmpleado =
          this.trabajadoresSeleccionados.map(
            trabajador => trabajador.codigo
          )
      }

      apiPost(vm, '/vacaciones/empleado/cambiodias', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Cambiado correctamente')
        vm.clear()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
      })
    },
    seleccionarEmpleado (o) {
      this.codigoEmpleado = o.codigo
      this.empleado = {}
      this.asignarEmpleadoExcepcion()
    },
    asignarEmpleadoExcepcion () {
      var vm = this
      var obj = {
      }
      apiGet(vm, '/vacaciones/empleado/uno/' + this.codigoEmpleado, obj, function (data) {
        vm.empleado = data.data
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    clear () {
      this.codigoEmpleado          = ''
      this.idArea                  = ''
      this.opcionCambiarDias       = 'individual'
      this.signo                   = '-'
      this.dias                    = 1
      this.motivo                  = ''
      this.fechaInicioQuitaDia     = moment().format('YYYY-MM-DD')
      this.fechaFinQuitaDia        = moment().add(1, 'day').format('YYYY-MM-DD')
      this.empleado                = {}
    },
    calculoDias () {
      var vm = this
      var desde = moment(vm.fechaInicioQuitaDia, 'YYYY-MM-DD');
      var hasta = moment(vm.fechaFinQuitaDia, 'YYYY-MM-DD');

      if (desde.isAfter(hasta)) {
        notify(vm, 'error', 'Validación', 'La Fecha inicial no puede ser mayor a la fecha final')
        return
      }

      vm.dias = hasta.diff(desde, 'days') + 1
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .name
    font-size 12px
    color #666
  .input-container
    display flex
    align-items center
    .input
      flex 1
      width 100px
    .erase-data
      cursor pointer
      margin-left 5px
  .item
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    display flex
    padding 10px
    margin-bottom 5px
    cursor pointer
    transition all .2s ease
  .cambio-dias
    .close
      position: absolute
      top 3px
      right 3px
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase
      .little
        font-size 14px

  .contenedor-datos
    display flex
    justify-content center
    >*
      transition: all 0.5s;

  .signo
    margin 10px
    .opciones
      display flex
      justify-content center
      .opcion

        flex 1
        border 1px solid #565cde
        margin 5px
        margin-top 10px
        transition all .3s ease
        cursor pointer
        padding 10px 0px
        &.is-selected
          background-color #565cde
          color white;
          font-weight bold

  .dias
    .control
      text-align center
      .input
        width 70px

  .flex-data
    display flex
    justify-content center
    margin-top 10px
    flex-direction column


  .acciones
    display flex
    margin-top 10px
    .button
      flex 1
      margin 5px
  .motivo
    .subtitle
      font-size 15px
      margin-bottom 0
      margin-top 3px
  .motivos-ejemplo
    display flex
    flex-direction column
    padding-left 10px
    margin 10px 0px 10px 10px
    text-align left
    border-left 3px solid #565cde
    span
      cursor pointer
      font-size 12px
      transition all .3s ease
      &:hover
        transform translateX(10px)
        color: #565cde

  .indicaciones
    flex 1
    padding 10px
    border 1px solid #209cee
    color: #12537e;
    background-color #f6fbfe
    display flex
    flex-direction column
    margin 10px
    max-width: 426px;

    strong
      color #209cee

    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 21px
      margin-bottom 5px

    .list
      display flex
      flex-direction column
      justify-content center
      flex 1
      text-align left
      .list-item
        padding-left 10px

  .codigo-empleado
    position relative
    .control
      text-align center
      .input
        width 100px

  .pop-over
      background: #fff;
      border-radius: 3px;
      border: 1px solid #d6dadc;
      border-bottom-color: #c4c9cc;
      -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
      box-shadow: 0 1px 6px rgba(0,0,0,.15);
      position: absolute;
      width: 300px;
      z-index: 70;
      top 0
      left: 0px;
  @media (max-width 975px)
    .contenedor-datos
      flex-direction: column;
    .indicaciones
      max-width: 100%;

  @media (max-width 800px)
    .contenedor-datos
      flex-direction: column;
    .indicaciones
      max-width: 100%;
.resumen-seleccion {
  width: 100%;
  max-width: 480px;
  margin: 10px auto 15px;
}

.resumen-contenido,
.sin-seleccion {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  border: 1px solid #d9dfff;
  border-left: 4px solid #536dfe;
  background: #f8f9ff;
  border-radius: 3px;
}

.resumen-contenido > .icon {
  margin-right: 10px;
  font-size: 18px;
}

.resumen-texto {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.resumen-texto span {
  margin-top: 3px;
  color: #777777;
  font-size: 12px;
}

.sin-seleccion {
  justify-content: space-between;
  color: #777777;
}

.button-small {
  padding: 6px 10px;
  font-size: 12px;
}

.button-small i {
  margin-right: 5px;
}

.margin-left-20 {
  margin-left: 20px
}
</style>



// WEBPACK FOOTER //
// Component_Cambio_Dias_Vacaciones.vue?95640f48